import { ClearRounded, SaveOutlined } from '@mui/icons-material';
import { Box, TextField, Tooltip } from '@mui/material';
import React, { useState } from 'react';

import { StyledIconButton } from '../../../../theme/CustomComponents';

interface CategoryFormProps {
  currentName?: string;
  onSave: (name: string) => void;
  onCancel: () => void;
}

const CategoryForm: React.FC<CategoryFormProps> = ({ currentName, onSave, onCancel }) => {
  const [name, setName] = useState<string | undefined>(currentName);

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, gap: 2 }}>
      <TextField
        size="small"
        variant="outlined"
        label="Category Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onClick={(e) => e.stopPropagation()}
        sx={{ width: '400px' }}
        autoFocus
      />
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Tooltip title="Save" arrow>
          <StyledIconButton
            onClick={(e) => {
              e.stopPropagation();
              if (name) {
                onSave(name);
              }
            }}
            disabled={!name}
          >
            <SaveOutlined />
          </StyledIconButton>
        </Tooltip>
        <Tooltip title="Cancel" arrow>
          <StyledIconButton
            onClick={(e) => {
              e.stopPropagation();
              onCancel();
            }}
          >
            <ClearRounded />
          </StyledIconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default CategoryForm;
